import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectTrialMode } from 'app/store/AppUI/AppUI.selectors';
import { selectAIChatEnabled } from 'app/store/Accounts/Accounts.selectors';
import { selectCaseAiChatEnabled } from 'app/store/Cases/Cases.selectors';
import { selectPagesInWorkspace } from 'app/store/page/page.selectors';
import { selectNewDesignEnabled } from 'app/store/pagesToolbar/pagesToolbar.selectors';
// Mui
import { Button, Tooltip } from '@mui/material';
import ConversationFormDialog from 'app/pages/Staff/CaseDetailsPage/AIChatPage/ConversationFormDialog';
// Components
import Icon from 'app/components/Icon';
import { IconButton } from 'app/components/Mui';
// Hooks
import useToggle from 'app/hooks/useToggle';
import useAccountStatus from 'app/hooks/useAccountStatus';
// Mixpanel
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';

const SendToAIChatButton = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // Selectors
  const trialMode = useAppSelector(selectTrialMode);
  const newDesignEnabled = useAppSelector(selectNewDesignEnabled);
  const aiChatEnabled = useAppSelector(selectAIChatEnabled);
  // ToDO
  const pages:any = useAppSelector(selectPagesInWorkspace);
  const caseAiChatEnabled = useAppSelector(selectCaseAiChatEnabled);

  const { isSuspended } = useAccountStatus();
  const { open, toggle } = useToggle();

  const handleSendToAiChatClick = () => {
    toggle();
    dispatch(MixpanelActions.handleCaseWorkspaceSendToAIChatClick());
  }

  const isAiChatButtonDisabled = !caseAiChatEnabled || isSuspended;

  if ( trialMode || !aiChatEnabled ) return null;
  return (
    <Fragment>
      {newDesignEnabled ? (
        <Tooltip title={t('buttons.sendToAiChat')}>
          <IconButton
            name="Send to ai chat"
            onClick={handleSendToAiChatClick}
            disabled={isAiChatButtonDisabled}
          ><Icon icon="send_to_ai_chat" /> </IconButton>
        </Tooltip>
      ) : (
        <Button
          disabled={isAiChatButtonDisabled}
          onClick={handleSendToAiChatClick}
          color="primary"
          variant="outlined"
          fullWidth
        >{t('buttons.sendToAiChat')}</Button>
      )}
      {open ? (
        <ConversationFormDialog
          open={open}
          onClose={toggle}
          pages={pages}
          source="workspace"
        />
      ) : null}
    </Fragment>
  )
}

export default SendToAIChatButton;
